// Start queuing up calls if Clarity hasn't loaded
window.clarity =
  window.clarity ||
  function () {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };

function setCookie(name, value, days) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

function getCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function init() {
  const clarityUid = getCookie('clarity_uid') || crypto.randomUUID();
  setCookie('clarity_uid', clarityUid, 365);

  const sessionId =
    window.sessionStorage.getItem('clarity_session_id') || crypto.randomUUID();
  window.sessionStorage.setItem('clarity_session_id', sessionId);

  window.clarity('identify', clarityUid, sessionId);
  window.clarity('set', 'session_id', sessionId);
  const didUpdate = sessionStorage.getItem('clarity_cart_updated');

  if (didUpdate === 'true') {
    return;
  }

  try {
    fetch(Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          clarity_uid: clarityUid,
          clarity_session_id: sessionId,
        },
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        console.debug(
          `Set session ID to ${sessionId} for user ${clarityUid}`,
          data,
        );

        sessionStorage.setItem('clarity_cart_updated', 'true');
      });
  } catch (e) {
    console.error(e);
  }
}

if (document.readyState === 'complete') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', () => {
    init();
  });
}
